import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import PlaylistVerticalTemplate from './playlistVerticalTemplate';
import PlaylistHorizontalTemplate from './playlistHorizontalTemplate';
import ThemeContext from '../../config/themeContext';
import * as TEMPLATES from '../../config/templates';

export default function PlayListTemplateManager({ config, videoPlayer, playlistmodel }) {
  const theme = useContext(ThemeContext);
  const GlobalStyles = createGlobalStyle` html {
    --primary-color: ${theme.colors.primary};
    --secundary-color: ${theme.colors.secoundary};
  }`;

  return (
    <>
      <GlobalStyles />
      {config.template === TEMPLATES.PLAYLIST_VERTICAL_TEMPLATE ? (
        <PlaylistVerticalTemplate
          config={config}
          videoPlayer={videoPlayer}
          playlistmodel={playlistmodel}
        />
      ) : (
        <PlaylistHorizontalTemplate
          config={config}
          videoPlayer={videoPlayer}
          playlistmodel={playlistmodel}
        />
      )}
    </>
  );
}

PlayListTemplateManager.propTypes = {
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
  playlistmodel: PropTypes.object.isRequired,
};
